import React, { useRef, useEffect } from 'react';
import { useLocation } from 'react-router';
import clsx from 'clsx';
import { AsideMenuAtc } from './AsideMenuAtc';
import {
  ScrollComponent,
  ToggleComponent,
  DrawerComponent,
} from '../../../assets/ts/components';
import { AsideMenuB2B } from './AsideMenuB2B';
import { AsideMenuOperations } from './AsideMenuOperations';
import { AsideMenuBusiness } from './AsideMenuBusiness';
import { AsideMenuErp } from './AsideMenuErp';
import { AsideMenuTacho } from './AsideMenuTacho';

type Props = {
  asideMenuCSSClasses: string[];
};

export const AsideMenu: React.FC<Props> = ({ asideMenuCSSClasses }) => {
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      ToggleComponent.reinitialization();
      ScrollComponent.reinitialization();
      DrawerComponent.reinitialization();
      if (scrollRef.current) {
        scrollRef.current.scrollTop = 0;
      }
    }, 50);
  }, [pathname]);

  return (
    <div
      id="kt_aside_menu_wrapper"
      ref={scrollRef}
      className="hover-scroll-overlay-y pt-2"
      data-kt-scroll="true"
      data-kt-scroll-activate="{default: false, lg: true}"
      data-kt-scroll-height="auto"
      data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
      data-kt-scroll-wrappers="#kt_aside_menu"
      data-kt-scroll-offset="0"
    >
      <div
        id="#kt_aside_menu"
        data-kt-menu="true"
        className={clsx(
          'menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500',
          asideMenuCSSClasses.join(' ')
        )}
      >
        <AsideMenuAtc />
        <AsideMenuB2B />
        <AsideMenuOperations />
        <AsideMenuTacho />
        <AsideMenuErp />
        <AsideMenuBusiness />
      </div>
    </div>
  );
};
